<section class="card">

    <div class="card-header">
      <title>Register of Inspection</title>
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Inspection</strong>
      </span>
  
      <span style="float: right">
        <!-- <a routerLink="/inspectionList"> -->
          <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
            <i class=" fa fa-chevron-circle-left"></i>
            Back
          </button>
        <!-- </a> -->
      </span>
      <!-- <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="!addBtn">
          <span>
            <i class="fa fa-save"></i>Generate Output</span>
        </button>
  </span> -->
      <meta charset="utf-8">
  
    </div>
  
    <form [formGroup]='inspectionForm' (document:click)="a.close();b.close();c.close()">
      <div class="modal-body">
        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <div _ngcontent-c1="" class="form-group ">
              <label class="form-control-label">Date of Inspection</label>
              <span _ngcontent-c1="" style="color: red;">*</span>
              <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" [maxDate]="TodayDate" [formControl]="inspectionForm.controls['dateOfInspection']" [(ngModel)]="dateOfInspectionModel"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="inspectiondate" ngbDatepicker #a="ngbDatepicker"
                  (click)="a.toggle()">
                <button class="input-group-addon" (click)="a.toggle()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              </div>
              <div *ngIf="inspectionForm.controls['dateOfInspection'].hasError('required') && inspectionForm.controls['dateOfInspection'].touched"
                class="form-control-error-custom">
                Date of Inspection is required*.
              </div>
            </div>
          </div>
  
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Time of Inspection : From</label>
  
            <!-- <input type="time" class="form-control" [formControl]="inspectionForm.controls.timeOfInspection"> -->
  
            <div class="form-group">
              <div class="input-group">
                <input type="text" class="form-control timepicker-init" [formControl]="inspectionForm.controls['inspectionTimefrom']" id="fromTimeOfInspection"
                  (focusout)="getTimeOfInspection()">
                <span class="input-group-addon">
                  <i class="icmn-clock"></i>
                </span>
              </div>
            </div>
          </div>
  
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>To</label>
            <!-- <input type="time" class="form-control" [formControl]="inspectionForm.controls.timeOfInspection"> -->
            <div class="form-group">
              <label class="input-group">
                <input type="text" class="form-control timepicker-init" [formControl]="inspectionForm.controls['inspectionTimeto']" id="toTimeOfInspection"
                  (focusout)="getTimeOfInspection1()">
                <span class="input-group-addon">
                  <i class="icmn-clock"></i>
                </span>
              </label>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="form-group  col-md-4 col-sm-6 col-xs-12">
            <label>Name of the person who inspected the registers and records
              <span _ngcontent-c1="" style="color: red;">*</span>
            </label>
  
            <input type="text" class="form-control" [formControl]="inspectionForm.controls.personwhoInspected">
            <div *ngIf="inspectionForm.controls['personwhoInspected'].hasError('pattern') && inspectionForm.controls['personwhoInspected'].touched"
              class="form-control-error-custom">
              Name of the person is invalid.
            </div>
            <div *ngIf="inspectionForm.controls['personwhoInspected'].hasError('required') && inspectionForm.controls['personwhoInspected'].touched"
              class="form-control-error-custom">
              Name of the person is required.
            </div>
  
          </div>
  
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Address of the person who inspected the registers and records </label>
            <textarea class="form-control" [formControl]="inspectionForm.controls.addressOfPerson"></textarea>
  
          </div>
  
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Designation of the person who inspected the registers and records </label>
            <input type="text" class="form-control" [formControl]="inspectionForm.controls.designationOfPerson">
            <div *ngIf="inspectionForm.controls['designationOfPerson'].hasError('pattern')" class="form-control-error-custom">
              Designation of the person who inspected the registers and records is invalid.
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Regd. Folio No/ DP Id and Client Id / Any other ID </label>
            <input type="text" class="form-control" [formControl]="inspectionForm.controls.regdID">
            <div *ngIf="inspectionForm.controls['regdID'].hasError('pattern')" class="form-control-error-custom">
              Regd. Folio No/ DP Id and Client Id / Any other ID is invalid.
            </div>
          </div>
  
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>No.of Shares / Debentures / Securities held </label>
            <br>
            <input type="text" class="form-control" [formControl]="inspectionForm.controls.shares">
  
          </div>
  
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Nature of Documents Inspected </label>
            <br>
            <input type="text" class="form-control" [formControl]="inspectionForm.controls.natureOfDocument">
  
          </div>
        </div>
  
        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Particulars of registers and records inspected</label>
            <textarea class="form-control" [formControl]="inspectionForm.controls.particulars"></textarea>
  
          </div>
  
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Whether any copy was provided to the person </label>
            <br>
            <div class="md-radio md-radio-inline" style="display: inline-block">
              <input id="copyYes" type="radio" [formControl]="inspectionForm.controls.copyProvided" style="position:absolute" name="copyProvided"
                value="Yes" class="form-check-input" checked="checked">
              <label for="copyYes" style="padding: 0 29px 0px 0px">Yes</label>
            </div>
            <div class="md-radio md-radio-inline" style="display: inline-block">
              <input id="copyNo" type="radio" [formControl]="inspectionForm.controls.copyProvided" style="position:absolute" name="copyProvided"
                value="No" class="form-check-input">
              <label for="copyNo">No</label>
            </div>
  
          </div>
  
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Fees, if any, received </label>
            <input type="text" class="form-control" [formControl]="inspectionForm.controls.fees">
  
          </div>
        </div>
  
        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
  
            <label class="form-group">Date of receipt of Fees for copy of records</label>
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [maxDate]="TodayDate" [formControl]="inspectionForm.controls['dateOfReceipt']" [(ngModel)]="dateOfReceiptModel"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="receiptdate" ngbDatepicker #b="ngbDatepicker"
                (click)="b.toggle()">
              <button class="input-group-addon" (click)="b.toggle()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
  
          </div>
  
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label class="form-group">Date of Supplying of Document</label>
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [maxDate]="TodayDate" [formControl]="inspectionForm.controls['dateOfSupply']" [(ngModel)]="dateOfSupplyModel"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="supplydate" ngbDatepicker #c="ngbDatepicker" (click)="c.toggle()">
              <button class="input-group-addon" (click)="c.toggle()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>
  
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Remarks, if any</label>
            <textarea class="form-control" [formControl]="inspectionForm.controls['remarks']" maxlength="200"></textarea>
  
          </div>
        </div>
      </div>
      <div class="card-footer" align="right">
        <!-- <div class="form-actions" style="text-align: right"> -->
        <button class="btn btn-sm btn-primary" (click)="showFormEntry()" [disabled]="!inspectionForm.valid || disabledOnclick" type="button" *ngIf="addBtn">Save</button>
        <!-- <button class="btn btn-sm btn-primary" (click)="generateOutput()" type="button" *ngIf="!addBtn">
          <span>
            <i class="fa fa-save"></i>Generate Output </span>
        </button> -->
        <button class="btn btn-sm btn-primary" (click)="updateInspectionData()" [disabled]="!inspectionForm.valid || disabledOnclick" type="button"
          *ngIf="!addBtn">Update</button>
        <!-- </div> -->
      </div>
    </form>
  
  
  
  </section>
  
  <app-alert></app-alert>